import _extends from 'babel-runtime/helpers/extends';
import _Object$assign from 'babel-runtime/core-js/object/assign';

import _ from 'lodash';
import TableList from '@/components/TableList/index.vue';
import channelColumn from './channel-column.vue';

export default {
  components: {
    TableList: TableList
  },

  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    columnConfig: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    tableConfig: {
      type: Object,
      default: function _default() {}
    },

    handleSelectionChange: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      tableColumnConfig: [{
        label: '选择',
        prop: 'selection',
        type: 'selection',
        selectable: function selectable(row, index) {
          return row.status !== 'published';
        }
      }, {
        label: '版本名称',
        prop: 'name'
      }, {
        label: '发布名称',
        prop: 'publishName'
      }, {
        label: '发布结果',
        prop: 'publishResult'
      }, {
        label: '版本描述',
        prop: 'description'
      }, {
        label: '语言',
        prop: 'language'
      }, {
        label: '渠道链接',
        prop: 'publish_channels',
        component: channelColumn,
        params: {
          isCopy: 1 // 展示channel拼接名称 + copy按钮
        }
      }, {
        label: '渠道',
        prop: 'channelName',
        component: channelColumn,
        width: 300,
        params: {
          isText: 1 // 仅展示channel拼接名称
        }
      }, {
        label: '创建时间',
        type: 'time',
        width: 150,
        prop: 'created_time'
      }, {
        label: '状态',
        width: 200,
        prop: 'status',
        params: {
          innerText: function innerText(_ref) {
            var row = _ref.row;

            var map = {
              'published': '已发布',
              'packed-success': '已打包',
              'unpacked': '待打包',
              'packed-fail': '打包失败'
            };
            return map[row.status] || '-';
          }
        }
      }, {
        label: 'DCO ID',
        prop: 'dco_id',
        params: {
          innerText: function innerText(_ref2) {
            var row = _ref2.row;

            return row.dco_id !== 0 ? row.dco_id : '-';
          }
        }
      }, {
        label: '来源',
        prop: 'type',
        params: {
          innerText: function innerText(_ref3) {
            var row = _ref3.row;

            return row.type === 1 ? '后台配置' : '前台配置';
          }
        }
      }, {
        prop: 'action-cell',
        slot: 'action-cell'
      }]
    };
  },


  computed: {
    innerTableConfig: function innerTableConfig() {
      return _Object$assign({}, _extends({}, this.tableConfig));
    },
    innerList: function innerList() {
      if (_.isArray(this.list)) {
        return this.list;
      }
      return [];
    },


    // 过滤表数据
    filterColumnConfig: function filterColumnConfig() {
      var _this = this;

      var tempConfig = [];
      this.columnConfig.map(function (columnProp) {
        _this.tableColumnConfig.map(function (item) {
          if (columnProp && item.prop === columnProp) {
            tempConfig.push(item);
          }
        });
      });

      return tempConfig;
    }
  },

  methods: {}
};